import data from './experience.json';

export default { ...data }